import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { DialogAnimation } from '@frontend/sports/modal/feature';
import { ModelPopupTypes } from '@frontend/sports/navigation/core/feature/url-helper';
import { QuickLinkViewModel } from '@frontend/sports/types/components/quick-links';
import { DynamicLayoutService } from '@frontend/vanilla/core';

import { PopupManager } from '../../../../lib/popup/popup-manager.service';
import { QUICK_LINKS } from '../../../../lib/quick-links/quick-links.bootstrap';
import { QuickLinksComponent as msQuickLinksComponent } from '../../../../lib/quick-links/quick-links.component';

@Component({
    selector: 'bs-digital-quick-links',
    template: '<vn-dynamic-layout-slot [slot]="slotQuickLinks" (click)="openMyBetsPopup($event)" />',
    encapsulation: ViewEncapsulation.Emulated,
    styles: [
        `
            .betslip-quick-links .list-item {
                border-bottom: 1px solid var(--betslip-border-color);
            }
            :host-context(bs-digital-linear-result) {
                .arrow {
                    display: none;
                }
            }
        `,
    ],
    standalone: false,
})
export default class QuickLinksComponent implements OnInit {
    @Input() context: string;
    @Output() linkClicked = new EventEmitter<QuickLinkViewModel>();
    @HostBinding('class') className = 'betslip-quick-links';
    readonly slotQuickLinks = QUICK_LINKS;

    constructor(
        private popupManager: PopupManager,
        private epcotConfig: EpcotConfig,
        private slot: DynamicLayoutService,
    ) {}

    ngOnInit(): void {
        this.slot.setComponent(this.slotQuickLinks, msQuickLinksComponent, { section: this.context });
    }

    openMyBetsPopup(e: Event): void {
        this.linkClicked.emit();
        e.stopPropagation();
        if (this.epcotConfig.isEnabled) {
            this.popupManager.updateDialogAnimation(ModelPopupTypes.MyBets, DialogAnimation.SlideInFromRight, true, true);
        }
    }
}
